module.exports = __webpack_public_path__ + "static/media/spacesCarouselIcon.e7b644d3.svg";